import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, AbstractControl, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { CustomValidators } from 'src/app/utils/custom-validator';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';

@Component({
  selector: 'class-maintenance',
  templateUrl: './class-maintenance.component.html',
  styleUrls: ['./class-maintenance.component.css']
})
export class ClassMaintenanceComponent implements OnInit {

  addUpdateFlag: boolean = true;
  datePipe = new DatePipe('en-us');
  selectedRow: any;
  tempNewData: any = [];
  tempUpdateData: any = [];
  userId: string = this.userDetailService.userId;
  errorMessage: string = '';
  saveDisabler: boolean = true;
  deleteDisabler: boolean = true;
  formHider: boolean = false;
  moduleId: string = 'BMM178';
  moduleName = this.jsonDataService.data.moduleList.filter((data: any) => { return data.moduleId === 'BMM178' })[0].moduleDesc.toUpperCase();
  
  classTable: any = {
    cols: [
      {
        key: "CLASS_CD",
        header: "Class Code",
        dataType: "string"
      },
      {
        key: "CLASS_NAME",
        header: "Class Name",
        dataType: "string"
      },
      {
        key: "CLASS_DESC",
        header: "Class Description",
        dataType: "string"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox"
      },
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }

  classForm = this.fb.group({
    CLASS_CD:           ['', [Validators.required, this.duplicateClassCd()]],
    CLASS_NAME:         ['', [Validators.required, CustomValidators.requiredTrim]],
    CLASS_DESC:         ['', [Validators.required, CustomValidators.requiredTrim]],
    ACTIVE_TAG:         ['A', [Validators.required]],
    REMARKS:            [''],
    USER_ID:            [{value: '', disabled: true}],
    LAST_UPDATE:        [{value: '', disabled: true}],
  });

  constructor(
    private fb: FormBuilder,
    private api: APICallService,
    private dialog: MatDialog,
    private jsonDataService: JsonDataService,
    private appMessageService: AppMessageService,
    private userDetailService: UserDetailsService,
    private formService: FormService,
    private securityService: SecurityService
  ) { }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempNewData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  duplicateClassCd(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const selectedRow = this.selectedRow;
      let shortDescDuplicate = this.classTable.tblData.filter(function(e: any) {
        return e.CLASS_CD.trim().toLowerCase()==control.value.trim().toLowerCase() && control.value!=selectedRow?.CLASS_CD;
      });
      if(shortDescDuplicate!='') {
        return { "shortDescDuplicate": "Class Code already exists. Please add a unique Class Code." }
      }
      return null;
    }
  }

  ngOnInit(): void {
    this.getClass();
  }

  getClass() {
    try {
      this.classTable.loading = true;
      this.jsonDataService.contorlLoading(true);
      this.api.getClassCd({
        moduleId: this.moduleId,
        userId: this.userDetailService.userId,
        type: "MODULE"
      }).subscribe((data: any) => {
        this.securityService.checkRequestKeyResponse(data, () => {
          this.securityService.hasValidCsrfToken(data, () => {
            if (data.status === "SUCCESS") {
              data = JSON.parse(this.jsonDataService.decrypt(data.response));
              data = data.data;
              this.classTable.loading = false;
              this.jsonDataService.contorlLoading(false);
              this.classTable.tblData = data;
              this.classTable.tblData = [
                ...this.classTable.tblData.filter((e: any) => e.ACTIVE_TAG === 'A'),
                ...this.classTable.tblData.filter((e: any) => e.ACTIVE_TAG === 'I')
              ];
            } else {
                this.jsonDataService.contorlLoading(false);
                this.classTable.loading = false;
                this.appMessageService.showAppMessage(data.message, "error");
            }
          });
        });
      });
    } catch(e) {
      
    }
  }

  onRowClick(ev: any): void {
    try {
      if(ev!=null) {
        this.selectedRow = ev;
        this.addUpdateFlag = false;
        this.formLoader();
      } else {
        this.selectedRow = '';
        this.addUpdateFlag = true;
        this.formClearer();
      }
      this.deleteEnabler();
    } catch(e) {
      
    }
  }

  formLoader() {
    try {
      this.classForm.get("CLASS_CD")?.disable();
      this.classForm.patchValue({
        CLASS_CD:           this.selectedRow.CLASS_CD,
        CLASS_NAME:         this.selectedRow.CLASS_NAME,
        CLASS_DESC:         this.selectedRow.CLASS_DESC,
        ACTIVE_TAG:         this.selectedRow.ACTIVE_TAG,
        REMARKS:            this.selectedRow.REMARKS,
        USER_ID:            this.selectedRow.USER_ID,
        LAST_UPDATE:        this.selectedRow.LAST_UPDATE,
      });
    } catch(e) {
      
    }
  }
  
  formClearer() {
    try {
      this.classForm.get("CLASS_CD")?.enable();
      this.classForm.patchValue({
        CLASS_CD:     '',
        CLASS_NAME:   '',
        CLASS_DESC:   '',
        ACTIVE_TAG:   'A',
        REMARKS:      '',
        USER_ID:      '',
        LAST_UPDATE:  '',
      });
    } catch(e) {
      
    }
  }

  deleteEnabler() {
    try {
      let tempDeleteFlag = this.tempNewData.filter((e: any) => {
        return e.CLASS_CD == this.selectedRow.CLASS_CD
      });
      if(tempDeleteFlag=='' || tempDeleteFlag==null) {
        this.deleteDisabler = true;
      } else {
        this.deleteDisabler = false;
      }
    } catch(e) {
      
    }
  }

  addRow(): void {
    try {
      if(this.classForm.valid) {
        this.formService.hideFormMsg("class-error-message");
        this.classTable.tblData.unshift(this.formValues());
        this.classTable.tblData = [...this.classTable.tblData];
        this.tempNewData.push(this.formValues());
        this.formClearer();
        this.saveDisabler = false;
      } else {
        this.errorMessageSetter();
      }
    } catch(e) {
      
    }
  }

  formValues(): any {
    try {
      return {
        CLASS_CD:           this.classForm.get('CLASS_CD')?.value,
        CLASS_NAME:         this.classForm.get('CLASS_NAME')?.value,
        CLASS_DESC:         this.classForm.get('CLASS_DESC')?.value,
        ACTIVE_TAG:         this.classForm.get('ACTIVE_TAG')?.value,
        REMARKS:            this.classForm.get('REMARKS')?.value,
        USER_ID:            this.userId,
        LAST_UPDATE:        this.classForm.get('LAST_UPDATE')?.value
      }
    } catch(e) {
      
    }
  }

  errorMessageSetter() {
    try {
      if(this.classForm.invalid) {
        for(const field in this.classForm.controls) {
          const controlName = this.classForm.get(field);
          if(controlName?.errors?.required) {
            this.errorMessage = 'There are missing information. Please provide necessary information needed.';
          }
          if(controlName?.errors?.shortDescDuplicate) {
            this.errorMessage = controlName?.errors?.shortDescDuplicate;
          }
          this.formService.showFormMsg("class-error-message", this.errorMessage, "E");
        }
      }
    } catch(e) {
      
    }
  }

  onUpdate(): void {
    try {
      if(this.classForm.valid) {
        this.updateTable();
        if(this.deleteDisabler) {
          this.updateDbData();
        } else {
          this.updateNewData();
        }
        this.selectedRow = '';
        this.addUpdateFlag = true;
        this.formClearer();
        this.saveDisabler = false;
        this.deleteEnabler();
        this.formService.hideFormMsg('class-error-message');
      } else {
        this.errorMessageSetter();
      }
    } catch(e) {
      
    }
  }

  updateTable() {
    try {
      let updateIndex = this.classTable.tblData.indexOf(this.selectedRow);
      this.classTable.tblData[updateIndex] = this.formValues();
      this.classTable.tblData = [...this.classTable.tblData];
    } catch(e) {
      
    }
  }

  updateDbData() {
    try {
      let tempDbData = this.tempUpdateData.find(
        (dbData: { CLASS_CD: any }) => dbData.CLASS_CD == this.selectedRow.CLASS_CD
      );
      if((this.tempUpdateData == '' || this.tempUpdateData == null) || (tempDbData=='' || tempDbData==null)) {
        this.tempUpdateData.push(this.formValues());
      } else {
        tempDbData.CLASS_CD           = this.classForm.get('CLASS_CD')?.value;
        tempDbData.CLASS_NAME         = this.classForm.get('CLASS_NAME')?.value;
        tempDbData.CLASS_DESC         = this.classForm.get('CLASS_DESC')?.value;
        tempDbData.ACTIVE_TAG         = this.classForm.get('ACTIVE_TAG')?.value;
        tempDbData.REMARKS            = this.classForm.get('REMARKS')?.value;
        tempDbData.USER_ID            = this.userId;
        tempDbData.LAST_UPDATE        = this.classForm.get('LAST_UPDATE')?.value;
      }
    } catch(e) {
      
    }
  }

  updateNewData() {
    try {
      let tempNewConfigdata = this.tempNewData.find(
        (e: { CLASS_CD: any }) => e.CLASS_CD == this.selectedRow.CLASS_CD
      );
      tempNewConfigdata.CLASS_CD           = this.classForm.get('CLASS_CD')?.value;
      tempNewConfigdata.CLASS_NAME         = this.classForm.get('CLASS_NAME')?.value;
      tempNewConfigdata.CLASS_DESC         = this.classForm.get('CLASS_DESC')?.value;
      tempNewConfigdata.ACTIVE_TAG         = this.classForm.get('ACTIVE_TAG')?.value;
      tempNewConfigdata.REMARKS            = this.classForm.get('REMARKS')?.value;
      tempNewConfigdata.USER_ID            = this.userId;
      tempNewConfigdata.LAST_UPDATE        = this.classForm.get('LAST_UPDATE')?.value;
    } catch(e) {
      
    }
  }

  deleteRow(): void {
    try {
      let clickedData = this.selectedRow;
      this.classTable.tblData = this.classTable.tblData.filter(function(e: any) {
        return e.CLASS_CD != clickedData.CLASS_CD;
      });
      this.tempNewData = this.tempNewData.filter(function(e: any) {
        return e.CLASS_CD != clickedData.CLASS_CD;
      });
      this.selectedRow = '';
      this.formClearer();
      this.deleteDisabler = true;
      this.addUpdateFlag = true;
      if((this.tempNewData=='' || this.tempNewData==null) && (this.tempUpdateData=='' || this.tempUpdateData==null)) {
        this.saveDisabler = true;
      }
    } catch(e) {
      
    }
  }

  onSave(): void {
    try {
      this.formHider = true;
      this.formService.showFormLoader(null, "class-form", "Saving.<br>Please wait ...", null, null);
      this.jsonDataService.contorlLoading(true);
      this.api.saveClassCd(this.tempNewData).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, () => {
            this.securityService.hasValidCsrfToken(data, () => {
              if(data.status == 'SUCCESS') {
                this.api.saveClassCd(this.tempUpdateData).subscribe({
                  next: (res: any) => {
                    this.securityService.checkRequestKeyResponse(res, () => {
                      this.securityService.hasValidCsrfToken(data, () => {
                        if(res.status == 'SUCCESS') {
                          this.onComplete();
                        } else {
                          this.onFail();
                        }
                      });
                    });
                  },
                  error: () => {
                    this.onFail();
                  }
                });
              } else {
                this.onFail();
              }
            });
          });
        },
        error: () => {
          this.onFail();
        }
      });
    } catch(e) {
      
    }
  }
  
  onComplete() {
    try {
      this.formService.hideFormLoader("class-form");
      this.formHider = false;
      this.tempNewData = [];
      this.tempUpdateData = [];
      this.saveDisabler = true;
      this.deleteEnabler();
      this.formClearer();
      this.getClass();
      this.formService.hideFormMsg("class-error-message");
      this.openSaveDialog();
    } catch(e) {
      
    }
  }

  onFail() {
    try {
      this.formService.hideFormLoader("class-form");
      this.formHider = false;
      this.tempNewData = [];
      this.tempUpdateData = [];
      this.deleteEnabler();
      this.formClearer();
      this.getClass();
      this.formService.hideFormMsg("class-error-message");
      this.openErrorDialog("Saving Class Failed");
    } catch(e) {
      
    }
  }

  openErrorDialog(message: string) {
    try {
      this.dialog.open(DialogMsgComponent, {
        disableClose: true,
        width: "500px",
        data: {
          title: 'ERROR',
          content: message,
        }
      });
    } catch(e) {
      
    }
  }

  openSaveDialog() {
    try {
      this.dialog.open(DialogMsgComponent, {
        disableClose: true,
        width: "500px",
        data: {
          title: 'SUCCESS',
          content: 'Class Details Successfully Saved!',
        }
      });
    } catch(e) {
      
    }
  }

}
